import { apiService } from "@/services/api/apiService";
import { unref } from "vue";

interface ILoginResponse {
  token: string;
  patientid: string;
}

export const API_Authorization_login = ({
  login,
  passwd,
}: {
  login: string;
  passwd: string;
}) => {
  return new Promise((resolve, reject) => {
    apiService
      .send({
        endpoint: "/api/login",
        method: "post",
        data: { login: unref(login), passwd: unref(passwd) },
      })
      .then((response) => {
        if (response.token && response.patientid) {
          apiService.setAuth(`${response.token}`, `${response.patientid}`);
          resolve(true);
        } else {
          reject(response);
        }
      })
      .catch((err) => reject(err));
  });
};
